import React, { useEffect, useState } from "react";
import OrderDetails from "../OrderDetails/OrderDetails";

const Orders = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  const [myOrders, setMyOrders] = useState([]);

  useEffect(() => {
    fetch(`https://infinite-cliffs-81680.herokuapp.com/customerOrder/${user.email}`)
      .then((res) => res.json())
      .then((data) => setMyOrders(data));
  });

  return (
    <div className="container mt-3">
      <div className="d-flex shadow p-3 rounded row">
        <div className="col-md-8 col-sm-12">
          <h4>Name: {user.name}</h4>
          <h5>Email: {user.email}</h5>
        </div>
        <div className="col-md-4 col-sm-12 justify-content-end">
          <img className="img-fluid" src={user.img} alt="" />
        </div>
      </div>
      {myOrders.length === 0 && (
        <div className="text-center mt-2">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <div className="mt-5">
        <table className="table">
          <thead>
            <tr>
              <th>Book Name</th>
              <th>Author Name</th>
              <th>Quantity</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            {myOrders.map((order) => (
              <OrderDetails order={order}></OrderDetails>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Orders;
